/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_File_Deleted_SuccessInputs */



/**
* | output |
* | --- |
* | "Transcript file deleted successfully" |
*
* @param {Transcript_File_Deleted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_file_deleted_success = /** @type {((inputs?: Transcript_File_Deleted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_File_Deleted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier de transcription supprimé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Protokolldatei wurde erfolgreich gelöscht.")
	if (locale === "it") return /** @type {LocalizedString} */ ("File di trascrizione eliminato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файл с расшифровкой успешно удален.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo de transcripción eliminado correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转录文件已成功删除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプトファイルが正常に削除されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रांसक्रिप्ट फ़ाइल सफलतापूर्वक हटा दी गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de transcrição excluído com sucesso")
	return /** @type {LocalizedString} */ ("Transcript file deleted successfully")
});